import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { getFirstResource, getQueryParameter } from '@ms/yammer-web-support/dist/location';
import { useEffect } from 'react';

type UseReportPageLoadedFromLinkClick = (pathname: string) => void;

export const useReportPageLoadedFromLinkClick: UseReportPageLoadedFromLinkClick = (pathname) => {
  const integrationOrigin = getQueryParameter('trk_integration_origin') as string;
  const notifId = getQueryParameter('trk_notif_id') as string;
  const outlookOrigin = getQueryParameter('trk_outlook_origin') as string;
  const subEvent = getQueryParameter('trk_event') as string;
  const scenarioType = getQueryParameter('trk_scenario_type') as string;
  const threadId = getQueryParameter('trk_thread_id') as string;
  const groupId = getQueryParameter('trk_group_id') as string;
  const storylineUserId = getQueryParameter('trk_storyline_user_id') as string;
  const scenarioSubType = getQueryParameter('trk_scenario_sub_type') as string;
  const copyLink = getQueryParameter('trk_copy_link') as string;
  const origin = integrationOrigin ?? outlookOrigin;

  useEffect(() => {
    if ((origin && scenarioType && subEvent) || copyLink) {
      const firstResource = getFirstResource(pathname);

      reportUsage({
        eventName: AnalyticsEventName.PageLoadedFromLinkClick,
        eventProperties: {
          storylineUserId,
          scenarioType,
          subEvent,
          integrationOrigin: origin,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          ...(notifId && { notif_id: notifId }),
          threadId,
          groupId,
          scenarioSubType,
          copyLink,
          ...(firstResource && { resourceId: firstResource }),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
